import { Grid } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import React from 'react';
import DisplayText from '../Texts/DisplayText';
import { ruleValidation } from './customFunctions';

const InputRating = (props) => {

    const {onChange, data, size} = props
    const {value, isVisited, isValid, disabled, isRequired} = props.data
    const {label, helper} = props.data.config

    const onInnerChange = (event, value) => {
        let temp = {...data};
        temp.value = value;
        temp.isValid = ruleValidation(temp.value, temp.rules, temp.value2);
        temp.isVisited = true;
        onChange(temp);
    }

    const error = isVisited && !isValid

    return ( 
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <DisplayText variant='subtitle2'  color={error ? 'error' : 'inherit'} style={{paddingBottom:6}}>{label}</DisplayText>
            </Grid>
            <Grid item xs={12}>
                <Rating max={10} size={size ? size : 'large'}  onChange={onInnerChange} value={value} readOnly={disabled}/>
            </Grid>
            <Grid item xs={12}>
                {error ? <DisplayText variant='caption' color='error'>{helper}</DisplayText> : null}
            </Grid>
        </Grid>
     );
}
 
export default InputRating;